import { Stack } from "@mui/material";
import React from "react";
import EditableBox from "../EditableBox";

export default function OrderedList({ children, updateParagraph }) {
  children = children.filter((child, index) => index % 2 === 1);

  return (
    <EditableBox
      sx={{
        paddingTop: "34px",
      }}
      children={children.map((child, index) => (
          <EditableBox children={[`${index + 1}. `, child.props.children]} updateParagraph={updateParagraph} />
      ))}
    />
  );
}
